import React, { useEffect } from "react";
import useGetAddress from "../walletsManagment/useGetAddress";
import "./styles.css";

import { btnFilterIcon } from "../../assets";

const Filter = ({ filtersState, chain, disabled }) => {
  const account = useGetAddress(chain);

  const { state, setState } = filtersState;
  const plotSizeChangeListener = (event) => {
    setState((state) => ({
      ...state,
      plotSize: event.target.value,
    }));
  };
  const plotPruchaseStatus = (event) => {
    setState((state) => ({
      ...state,
      plotStatus: event.target.value,
      showMyPlots: false,
    }));
  };

  const myPlotsClickListener = (event) => {
    setState((state) => ({
      ...state,
      plotStatus: event.target.value,
      showMyPlots: true,
    }));
  };

  useEffect(() => {
    if (!account && state.showMyPlots) {
      setState((state) => ({
        ...state,
        plotStatus: "all",
        plotSize: "all",
        showMyPlots: false,
      }));
    }
  }, [account]);

  return (
    <div className="left-filter dropdown filterDropdown ">
      <button
        className="custom-btn icon-btn md black-bg dropdown-toggle"
        type="button"
        id="dropdownMenuButtonPlotsFilers"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={disabled}
      >
        <img src={btnFilterIcon} alt="filter" />

        <span className="btn-txt">filters</span>
      </button>

      <div
        className="dropdown-menu"
        aria-labelledby="dropdownMenuButtonPlotsFilers"
      >
        <div className="d-flex">
          <div className="plots-size">
            <button
              className={`custom-btn light-bg sm ${
                state.plotSize == "all" ? "active" : "disactive"
              }`}
              onClick={plotSizeChangeListener}
              value="all"
            >
              All
            </button>
            <button
              className={`custom-btn light-bg sm ${
                state.plotSize == "SMALL" ? "active" : "disactive"
              }`}
              onClick={plotSizeChangeListener}
              value="SMALL"
            >
              Small
            </button>
            <button
              className={`custom-btn light-bg sm ${
                state.plotSize == "MEDIUM" ? "active" : "disactive"
              }`}
              onClick={plotSizeChangeListener}
              value="MEDIUM"
            >
              Medium
            </button>
            <button
              className={`custom-btn light-bg sm ${
                state.plotSize == "LARGE" ? "active" : "disactive"
              }`}
              onClick={plotSizeChangeListener}
              value="LARGE"
            >
              Large
            </button>
          </div>
          <div className="plots">
            <button
              className={`custom-btn light-bg sm ${
                state.plotStatus == "all" ? "active" : "disactive"
              }`}
              onClick={plotPruchaseStatus}
              value="all"
            >
              All
            </button>
            <button
              className={`custom-btn light-bg sm ${
                state.plotStatus == "SOLD" ? "active" : "disactive"
              }`}
              onClick={plotPruchaseStatus}
              value="SOLD"
            >
              Sold
            </button>
            <button
              className={`custom-btn light-bg sm ${
                state.plotStatus == "AVAILABLE" ? "active" : "disactive"
              }`}
              onClick={plotPruchaseStatus}
              value="AVAILABLE"
            >
              Available
            </button>

            <div className={account ? `my-plots` : `my-plots invisible d-none`}>
              <button
                className={`custom-btn light-bg sm ${
                  state.showMyPlots ? "active" : "disactive"
                }`}
                onClick={myPlotsClickListener}
                value="MYPLOTS"
              >
                My Plots
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
